import React, {useEffect, useContext, useState} from 'react';
import {Tabs} from 'antd';
import {EyeOutlined, CodeOutlined} from '@ant-design/icons';
import {set} from 'lodash';
import {OpenApiContext} from '../../openapi-context';
import {TechnicalEditor} from '../technical-editor';
import {Block} from '../block';
import {LicenseBlock} from './license-block';

export function LicenseView({spec, dispatch, rootPath, checkView}) {
    const [contactData, setcontactData] = useState();
    const openapi = useContext(OpenApiContext);

    useEffect(() => {
        if (openapi.state.info) {
            const state = {};
            set(state, 'info', openapi.state.info());
            setcontactData(state);
        }
    }, [openapi.state]);

    function onTechnicalEdit(spec) {
        dispatch({type: 'update-info', spec});
    }

    function onSchemaSave(info) {
        return function (spec) {
            dispatch({type: 'update-info', spec});
        };
    }

    return contactData ? (
        <div className="frontpage">
            <Tabs
                type="card"
                tabPlacement="right"
                id="modelTabs"
                items={[
                    {
                        key: 'visual',
                        label: <EyeOutlined />,
                        children: (
                            <div className="scrollableViewer">
                                <LicenseBlock schema={spec.info} onSave={onSchemaSave(spec)} rootPath={rootPath} checkView={checkView} />
                            </div>
                        ),
                    },
                    {
                        key: 'technical',
                        label: <CodeOutlined />,
                        disabled: openapi.state.editMode,
                        children: (
                            <Block noEdit>
                                <TechnicalEditor object={spec.info} update={onTechnicalEdit} />
                            </Block>
                        ),
                    },
                ]}
            />
        </div>
    ) : null;
}
